<canvas id="cursorCanvas"></canvas>
